import React from "react";
import { useSelector } from "react-redux";

const Copyright = () => {
  const version = useSelector((state) => state.appSettings.version || "(N/A)");
  return (
    <div className="row w-100 m-0">
      <div className="card w-100 p-0 m-2">
        <div className="card-body">
          <small>
            <p className="pb-0 mb-0">
              Copyright (c) 2026 California Department of Transportation. All rights
              reserved.
              <br />
              <em>{`v${version}`}</em>
            </p>
          </small>
        </div>
      </div>
    </div>
  );
};

export default Copyright;
